import { render } from "./SmDeleteComponent.vue?vue&type=template&id=9c8b3088"
import script from "./SmDeleteComponent.vue?vue&type=script&lang=js"
export * from "./SmDeleteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmDeleteComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c8b3088"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c8b3088', __exports__)) {
    api.reload('9c8b3088', __exports__)
  }
  
  module.hot.accept("./SmDeleteComponent.vue?vue&type=template&id=9c8b3088", () => {
    api.rerender('9c8b3088', render)
  })

}


export default __exports__